

interface ireply {
  name: string,
  price: string,
  icon: string,
}
interface idata {
  data: Array<ireply>,
  type: string,
  width: number
}
export default {
  name: 'App',
  components: {},
  data (): idata {
    return {
      data: [
        {
          name: 'target1',
          price: '11',
          icon: '💰'
        }, {
          name: 'target2',
          price: '10',
          icon: '🌲'
        }, {
          name: 'target3',
          price: '51',
          icon: '👱🏿‍♂️'
        }, {
          name: 'target4',
          price: '31',
          icon: '👻'
        }, {
          name: 'target5',
          price: '14s',
          icon: '¢'
        }
      ],
      type: 'sort',
      width: 400
    }
  },
  methods: {
    getData (reply: Array<ireply>): void {
      window.console.log('here comes data after sorted', reply)
    }
  }
}
